import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = { class: "review-draft" }
const _hoisted_2 = { class: "loading" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "p__style__4" }
const _hoisted_5 = { class: "item-area" }
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "button-area" }

import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { useRoute, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewDraft',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const loading = ref(false);

const content = ref("");
const resouces = ref<{ url: string; resource_order: number, type: string }[]>([]);

onMounted(() => {
  const list = JSON.parse(String(route.query.resouces)) || [];
  if (Array.isArray(list) && list.length)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
    list.forEach((v: any) => {
      resouces.value.push(v);
    });
  content.value = String(route.query.content);
});

function back() {
  router.back();
}

function previewPhoto(url: string) {
  window.open(url);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _cache[1] || (_cache[1] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
    ]), 512 /* NEED_PATCH */), [
      [_vShow, loading.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "detail-title" }, "下書き内容", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_4, _toDisplayString(content.value), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resouces.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item"
        }, [
          (item.type == 'image')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.url,
                alt: "アップロード写真",
                onClick: ($event: any) => (previewPhoto(item.url))
              }, null, 8 /* PROPS */, _hoisted_6))
            : (_openBlock(), _createElementBlock("video", {
                key: 1,
                src: item.url,
                alt: "アップロード動画",
                controls: ""
              }, null, 8 /* PROPS */, _hoisted_7))
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(CommonButton, {
        data: {
          status: 0,
          button: `戻る`,
        },
        style: {"max-width":"317px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
      })
    ])
  ]))
}
}

})